define('models/hybridAd',["T1", "T1Model"], function (T1, T1Model) {
  T1.Models.HybridAd = T1Model.extend({});
  return T1.Models.HybridAd;
});
